import { useEffect, useState } from 'react';
import { ConfirmDialog } from '@vipso/shared';
import {
  applyOtaUpdate,
  dismissOtaUpdate,
  onOtaUpdateReady,
  type OtaUpdateReady,
} from '../liveUpdateService';

/** Prompts to restart when a self-hosted OTA bundle is downloaded. */
export function OtaUpdateDialog() {
  const [update, setUpdate] = useState<OtaUpdateReady | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    onOtaUpdateReady(setUpdate);
    return () => onOtaUpdateReady(null);
  }, []);

  if (!update) return null;

  return (
    <ConfirmDialog
      opened
      title="Update ready"
      message={`Version ${update.version} is downloaded. Restart now to apply it?`}
      confirmLabel="Restart"
      cancelLabel="Later"
      loading={loading}
      onClose={() => {
        dismissOtaUpdate(update.version);
        setUpdate(null);
      }}
      onConfirm={() => {
        setLoading(true);
        void applyOtaUpdate(update.bundleId).finally(() => setLoading(false));
      }}
    />
  );
}
